(self["webpackChunk_N_E"] = self["webpackChunk_N_E"] || []).push([[6619],{

/***/ 30274:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Z": function() { return /* binding */ LoadingBM; }
/* harmony export */ });
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var _material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(95477);
/* harmony import */ var constants_Images__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(13270);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(43931);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(59621);
/* harmony import */ var _styles_module_css__WEBPACK_IMPORTED_MODULE_3___default = /*#__PURE__*/__webpack_require__.n(_styles_module_css__WEBPACK_IMPORTED_MODULE_3__);





function LoadingBM() {
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)("div", {
        className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().wrapLoad),
        children: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsxs)("div", {
            className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().wrapper),
            children: [
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_2__/* .ImageFallbackStatic */ .ez, {
                    src: constants_Images__WEBPACK_IMPORTED_MODULE_1__/* .LOGO_THUOCSI_SHORTENED */ .SlS,
                    width: 45,
                    height: 45
                }),
                /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(_material_ui_core_CircularProgress__WEBPACK_IMPORTED_MODULE_4__/* ["default"] */ .Z, {
                    size: 80,
                    thickness: 4,
                    className: (_styles_module_css__WEBPACK_IMPORTED_MODULE_3___default().progress)
                })
            ]
        })
    });
};


/***/ }),

/***/ 19862:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "Z": function() { return /* binding */ mocules_TagComponent; },
  "T": function() { return /* binding */ getShowTags; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_to_consumable_array.mjs + 2 modules
var _to_consumable_array = __webpack_require__(29815);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./node_modules/@mui/material/Box/Box.js + 2 modules
var Box = __webpack_require__(19238);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/styles/withStyles.js + 1 modules
var withStyles = __webpack_require__(1591);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./src/components/mocules/TagType/index.js + 1 modules
var TagType = __webpack_require__(85201);
// EXTERNAL MODULE: ./src/components/atoms/AdditionalTooltip/styles.module.css
var styles_module = __webpack_require__(84446);
var styles_module_default = /*#__PURE__*/__webpack_require__.n(styles_module);
;// CONCATENATED MODULE: ./src/components/atoms/AdditionalTooltip/index.js








var AdditionalTooltip = function(param) {
    var tags = param.tags, _exp = param.exp, exp = _exp === void 0 ? null : _exp, isProductDetailNew = param.isProductDetailNew;
    var CustomizeTooltip = (0,withStyles/* default */.Z)({
        tooltip: {
            backgroundColor: "#ffffff",
            border: "1px solid #eaeaea",
            display: "flex",
            justifyContent: "space-beetwen",
            flexWrap: "wrap"
        },
        arrow: {
            "&:before": {
                border: "1px solid #eaeaea",
                backgroundColor: "#ffffff"
            }
        }
    })(Tooltip/* default */.ZP);
    var remainTagType = tags === null || tags === void 0 ? void 0 : tags.map(function(tag) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            style: {
                padding: "2px"
            },
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(TagType/* default */.ZP, {
                item: tag,
                exp: exp,
                isProductDetailNew: isProductDetailNew
            })
        }, tag);
    });
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(CustomizeTooltip, {
        title: remainTagType,
        disableFocusListener: true,
        disableTouchListener: true,
        className: (0,clsx/* default */.Z)((styles_module_default()).tag_quantity),
        arrow: true,
        children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Box/* default */.Z, {
            className: (styles_module_default()).tag,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                style: {
                    marginBottom: "8px"
                },
                children: "..."
            })
        })
    });
};
/* harmony default export */ var atoms_AdditionalTooltip = (AdditionalTooltip);

// EXTERNAL MODULE: ./src/constants/TagTypeProps/index.js
var TagTypeProps = __webpack_require__(11917);
// EXTERNAL MODULE: ./src/constants/Tags/index.js
var Tags = __webpack_require__(91983);
// EXTERNAL MODULE: ./node_modules/react/index.js
var react = __webpack_require__(67294);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/zustand-lib/storeGlobal.js + 2 modules
var storeGlobal = __webpack_require__(31439);
;// CONCATENATED MODULE: ./src/components/mocules/TagComponent/index.js
// xử lý tag









/*
TAG
Rule 1: 3 Tag Priority bắt buộc phải hiển thị đủ: Thứ tự ưu tiên hiển thị: Cận date (text) - Hóa đơn nhanh (có icon) - Đặt trước 7 ngày (text) (các tags còn lại có thể nằm trong nút …)
Rule 2: Sp chứa Tag text (>1) và tag icon (>1) sẽ hiển thị:
Th1: nếu có tag priority → ưu tiển hiển thị theo Rule 1
TH2: nếu không có tag priority → hiển thị 1 tag text và 2 tag icon (đảm bảo là nằm trên cùng 1 dòng)
Rule 3: nếu ko có tags icon nào hiển thị thì sẽ hiển thị tags có chữ ra ngoài, max là 2 tags text (cho phép rớt xuống thành 2 dòng ở trường hợp này)
Giao diện chỗ +number đổi thành nút ba chấm … (đang chờ update UI để update vô card, dev cứ giữ … như bản web hiện tại là dc) (rule của nút vẫn giữ như trong card)
  */ var tagsHidden = [
    sysconfig/* TAG_NEW */.cC
];
var TAG_PRIORITY = [
    "NEAR_EXPIRATION",
    "HOADONNHANH",
    "HANG_DAT_TRUOC"
];
var tagHideHoaDonNhanh = [
    Tags/* PRODUCT_TAG.HANG_DIEM */.d.HANG_DIEM,
    Tags/* PRODUCT_TAG.HANG_HANG */.d.HANG_HANG
];
var TAG_PRIORITY_LAYOUTDETAIL = [
    "HOADONNHANH",
    Tags/* PRODUCT_TAG.HANG_HANG */.d.HANG_HANG,
    Tags/* PRODUCT_TAG.HANG_DIEM */.d.HANG_DIEM,
    "HANG_DAT_TRUOC",
    Tags/* PRODUCT_TAG.KHUYENMAI */.d.KHUYENMAI,
    "NEAR_EXPIRATION", 
];
var getShowTags = function(tags, getStyleBySlugOfTag, provinceCode) {
    // Cận date- Hóa đơn nhanh - Đặt trước 7 ngày - Có ở kho - Bán Chạy - Giá Tốt - Nhãn hàng 3 tốt
    var sortprioritizedTag = tags === null || tags === void 0 ? void 0 : tags.filter(function(tag) {
        return (TagTypeProps/* default */.Z[tag] || getStyleBySlugOfTag && getStyleBySlugOfTag(tag)) && tagsHidden.indexOf(tag) === -1;
    }).sort(function(a, b) {
        var ref, ref1;
        return (((ref = TagTypeProps/* default */.Z[b]) === null || ref === void 0 ? void 0 : ref.index) || 10) - (((ref1 = TagTypeProps/* default */.Z[a]) === null || ref1 === void 0 ? void 0 : ref1.index) || 10);
    });
    // bỏ duplicate
    var setTags = Array.from(new Set(sortprioritizedTag));
    // 05Augh2022
    /*
    nếu SP có tag hàng hãng / hàng điểm thì auto ẩn Tag hoá đơn nhanh
    ẩn trên toàn bộ trang
    khi ẩn tag hoá đơn nhanh thì sẽ ưu tiên  Hàng hãng -> Hàng Điểm
    https://buymed.atlassian.net/browse/APO-772
  */ var indexTagHoaDonNhanh = setTags.indexOf(Tags/* PRODUCT_TAG.HOADONNHANH */.d.HOADONNHANH);
    if (indexTagHoaDonNhanh >= 0 && setTags.some(function(tag) {
        return tagHideHoaDonNhanh.includes(tag);
    })) {
        setTags.splice(indexTagHoaDonNhanh, 1);
    }
    // check user miền bắc chỉ hiển thị tag HANG_DAT_TRUOC
    var isUserInRegionMb = sysconfig/* REGION_MB.indexOf */.nt.indexOf("".concat(provinceCode)) < 0;
    var indexTagHangDatTruoc = setTags.indexOf(sysconfig/* TAG_HANG_DAT_TRUOC */.lE);
    if (indexTagHangDatTruoc >= 0 && isUserInRegionMb) {
        setTags.splice(indexTagHangDatTruoc, 1);
    }
    return setTags;
};
var TagComponent = function(param) {
    var product = param.product, _isProductCard = param.isProductCard, isProductCard = _isProductCard === void 0 ? true : _isProductCard, _isSellerList = param.isSellerList, isSellerList = _isSellerList === void 0 ? false : _isSellerList, _isCombo = param.isCombo, isCombo = _isCombo === void 0 ? false : _isCombo, _isGift = param.isGift, isGift = _isGift === void 0 ? false : _isGift, _isShowDeal = param.isShowDeal, isShowDeal = _isShowDeal === void 0 ? true : _isShowDeal, link = param.link, isLinkTagDeal = param.isLinkTagDeal, _isPopupPriceFluctuation = param.isPopupPriceFluctuation, isPopupPriceFluctuation = _isPopupPriceFluctuation === void 0 ? false : _isPopupPriceFluctuation, _isProductDetailNew = param.isProductDetailNew, isProductDetailNew = _isProductDetailNew === void 0 ? false : _isProductDetailNew, sku = param.sku;
    var ref;
    var getStyleBySlugOfTag = (0,storeGlobal/* useStore */.oR)(function(state) {
        return state === null || state === void 0 ? void 0 : state.getStyleBySlugOfTag;
    }) || null;
    var user = (0,storeGlobal/* useStore */.oR)(function(state) {
        return state === null || state === void 0 ? void 0 : state.user;
    }) || null;
    // nếu gift thì không hiển thị tag
    if (isSellerList || isGift) {
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {});
    }
    product.tags = (product === null || product === void 0 ? void 0 : (ref = product.tags) === null || ref === void 0 ? void 0 : ref.length) > 0 ? product.tags.filter(function(tag) {
        return tag !== Tags/* PRODUCT_TAG.HOADONNHANH */.d.HOADONNHANH;
    }) : [];
    var ref1 = product || {}, _tags = ref1.tags, tags = _tags === void 0 ? [] : _tags, _statusData = ref1.statusData, statusData = _statusData === void 0 ? {} : _statusData, _expiredDate = ref1.expiredDate, expiredDate = _expiredDate === void 0 ? "" : _expiredDate, _isProductDetailPage = ref1.isProductDetailPage, isProductDetailPage = _isProductDetailPage === void 0 ? false : _isProductDetailPage, _isHangDiemStore = ref1.isHangDiemStore, isHangDiemStore = _isHangDiemStore === void 0 ? false : _isHangDiemStore, iconHangDiem = ref1.iconHangDiem;
    // nếu combo chỉ hiển thị tag hoá đơn nhanh
    if (isCombo) {
        return tags === null || tags === void 0 ? void 0 : tags.filter(function(tag) {
            return tag === Tags/* PRODUCT_TAG.HOADONNHANH */.d.HOADONNHANH || tag === sysconfig/* TAG_HANG_DAT_TRUOC */.lE;
        }).map(function(item, index) {
            /*#__PURE__*/ return (0,jsx_runtime.jsx)(TagType/* default */.ZP, {
                item: item,
                exp: statusData === null || statusData === void 0 ? void 0 : statusData.date,
                isTooltip: isProductCard && TagType/* tagTypePropsArr.indexOf */.fb.indexOf(item),
                link: link,
                isLinkTagDeal: isLinkTagDeal
            }, "".concat(sku, "-").concat(index));
        });
    }
    // Cận date- Hóa đơn nhanh - Đặt trước 7 ngày - Có ở kho - Bán Chạy - Giá Tốt - Nhãn hàng 3 tốt
    var sortprioritizedTag = tags === null || tags === void 0 ? void 0 : tags.filter(function(tag) {
        return (TagTypeProps/* default */.Z[tag] || getStyleBySlugOfTag && getStyleBySlugOfTag(tag)) && tagsHidden.indexOf(tag) === -1;
    }).sort(function(a, b) {
        var ref, ref1;
        return (((ref = TagTypeProps/* default */.Z[b]) === null || ref === void 0 ? void 0 : ref.index) || 10) - (((ref1 = TagTypeProps/* default */.Z[a]) === null || ref1 === void 0 ? void 0 : ref1.index) || 10);
    });
    // bỏ duplicate
    var setTags = Array.from(new Set(sortprioritizedTag));
    // 05Augh2022
    /*
    nếu SP có tag hàng hãng / hàng điểm thì auto ẩn Tag hoá đơn nhanh
    ẩn trên toàn bộ trang
    khi ẩn tag hoá đơn nhanh thì sẽ ưu tiên  Hàng hãng -> Hàng Điểm
    https://buymed.atlassian.net/browse/APO-772
  */ // const indexTagHoaDonNhanh = setTags.indexOf(PRODUCT_TAG.HOADONNHANH);
    // if (indexTagHoaDonNhanh >= 0 && setTags.some((tag) => tagHideHoaDonNhanh.includes(tag))) {
    //   setTags.splice(indexTagHoaDonNhanh, 1);
    // }
    // check user miền bắc chỉ hiển thị tag HANG_DAT_TRUOC
    var isUserInRegionMb = sysconfig/* REGION_MB.indexOf */.nt.indexOf("".concat(user === null || user === void 0 ? void 0 : user.provinceCode)) < 0;
    var indexTagHangDatTruoc = setTags.indexOf(sysconfig/* TAG_HANG_DAT_TRUOC */.lE);
    if (indexTagHangDatTruoc >= 0 && isUserInRegionMb) {
        setTags.splice(indexTagHangDatTruoc, 1);
    }
    // Ở trang giỏ hàng thì  không hiển thị tag DEAL
    if (!isShowDeal) {
        var indexDeal = setTags.indexOf("DEAL");
        if (indexDeal >= 0) {
            setTags.splice(indexDeal, 1);
        }
    }
    // thêm rule 28Jun2022
    // nếu có 3 tag thì hiển thị hết
    // isProductCard  = true -> hiển thị icon , và rule ở trên
    var tagPriorityCur;
    var remainTags = [];
    if (isProductDetailNew) {
        var newTags = TAG_PRIORITY_LAYOUTDETAIL.map(function(item, index) {
            return {
                value: item,
                index: index + 1
            };
        }).filter(function(t) {
            return setTags.indexOf(t === null || t === void 0 ? void 0 : t.value) >= 0;
        }).sort(function(t1, t2) {
            return (t1 === null || t1 === void 0 ? void 0 : t1.index) < (t2 === null || t2 === void 0 ? void 0 : t2.index);
        });
        tagPriorityCur = setTags.filter(function(t) {
            return TAG_PRIORITY_LAYOUTDETAIL.indexOf(t) >= 0;
        });
        remainTags = setTags.filter(function(tag) {
            return tagPriorityCur.indexOf(tag) === -1;
        });
        if (newTags.length > 2) {
            var itemLimit = (0,_to_consumable_array/* default */.Z)(newTags).map(function(x) {
                return x === null || x === void 0 ? void 0 : x.value;
            });
            itemLimit.splice(0, 2);
            newTags = newTags.slice(0, 2);
            if (remainTags && remainTags.length > 0) {
                remainTags = (0,_to_consumable_array/* default */.Z)(itemLimit).concat((0,_to_consumable_array/* default */.Z)(remainTags));
            } else {
                remainTags = itemLimit;
            }
        }
        if (remainTags.length > 0 && newTags.length < 1) {
            var valueShilf = (0,_to_consumable_array/* default */.Z)(remainTags);
            valueShilf.shift();
            return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
                children: [
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(TagType/* default */.ZP, {
                        item: remainTags[0],
                        exp: remainTags[0] === "NEAR_EXPIRATION" ? expiredDate : statusData === null || statusData === void 0 ? void 0 : statusData.date,
                        isTooltip: isProductCard && TagType/* tagTypePropsArr.indexOf */.fb.indexOf(remainTags[0]),
                        isLinkTagDeal: isLinkTagDeal,
                        link: link,
                        isProductDetailNew: true
                    }, "".concat(sku)),
                    (valueShilf === null || valueShilf === void 0 ? void 0 : valueShilf.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_AdditionalTooltip, {
                        tags: valueShilf,
                        isProductDetailNew: isProductDetailNew
                    })
                ]
            });
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (newTags === null || newTags === void 0 ? void 0 : newTags.length) > 0 && newTags.map(function(item, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TagType/* default */.ZP, {
                        item: item === null || item === void 0 ? void 0 : item.value,
                        exp: (item === null || item === void 0 ? void 0 : item.value) === "NEAR_EXPIRATION" ? expiredDate : statusData === null || statusData === void 0 ? void 0 : statusData.date,
                        isTooltip: isProductCard && TagType/* tagTypePropsArr.indexOf */.fb.indexOf(item === null || item === void 0 ? void 0 : item.value),
                        isLinkTagDeal: isLinkTagDeal,
                        link: link,
                        isProductDetailNew: true
                    }, "".concat(sku, "-").concat(index));
                }),
                (remainTags === null || remainTags === void 0 ? void 0 : remainTags.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_AdditionalTooltip, {
                    tags: remainTags,
                    isProductDetailNew: isProductDetailNew
                })
            ]
        });
    }
    if ((isProductCard || isPopupPriceFluctuation) && (setTags === null || setTags === void 0 ? void 0 : setTags.length) > 3) {
        // check có tag priority không
        // rule 1
        tagPriorityCur = setTags.filter(function(t) {
            return TAG_PRIORITY.indexOf(t) >= 0;
        });
        // rule 2 : nếu không có tagPriority -> 1 tag tex & 1 tag icon
        if ((tagPriorityCur === null || tagPriorityCur === void 0 ? void 0 : tagPriorityCur.length) === 0) {
            var tagIcons = [];
            var tagNoIcons = [];
            var tagStyles = setTags.map(function(tag) {
                return TagTypeProps/* default */.Z[tag] || getStyleBySlugOfTag && getStyleBySlugOfTag(tag);
            });
            tagStyles.forEach(function(tag) {
                if (tag) {
                    if (tag.isTooltip) {
                        tagIcons.push(tag === null || tag === void 0 ? void 0 : tag.code);
                    } else {
                        tagNoIcons.push(tag === null || tag === void 0 ? void 0 : tag.code);
                    }
                }
            });
            // nếu có 2 tag icon -> 1 icon 1 text
            if ((tagIcons === null || tagIcons === void 0 ? void 0 : tagIcons.length) >= 1 && (tagNoIcons === null || tagNoIcons === void 0 ? void 0 : tagNoIcons.length) > 0) {
                tagPriorityCur = (0,_to_consumable_array/* default */.Z)(tagIcons.splice(0, 2)).concat([
                    tagNoIcons === null || tagNoIcons === void 0 ? void 0 : tagNoIcons[0]
                ]);
            } else {
                // nếu không có 2 tag Icon thì sẽ hiển thị 2 tag text
                tagPriorityCur = tagNoIcons.splice(0, 2);
            }
        }
        remainTags = setTags.filter(function(tag) {
            return tagPriorityCur.indexOf(tag) === -1;
        });
        if ((tagPriorityCur === null || tagPriorityCur === void 0 ? void 0 : tagPriorityCur.length) <= 2) {
            tagPriorityCur = tagPriorityCur.concat(remainTags.splice(0, 3 - tagPriorityCur.length));
        }
        return /*#__PURE__*/ (0,jsx_runtime.jsxs)(jsx_runtime.Fragment, {
            children: [
                (tagPriorityCur === null || tagPriorityCur === void 0 ? void 0 : tagPriorityCur.length) > 0 && tagPriorityCur.map(function(item, index) {
                    /*#__PURE__*/ return (0,jsx_runtime.jsx)(TagType/* default */.ZP, {
                        item: item,
                        exp: item === "NEAR_EXPIRATION" ? expiredDate : statusData === null || statusData === void 0 ? void 0 : statusData.date,
                        isTooltip: isProductCard && TagType/* tagTypePropsArr.indexOf */.fb.indexOf(item),
                        isLinkTagDeal: isLinkTagDeal,
                        link: link,
                        isProductDetailPage: isProductDetailPage,
                        isHangDiemStore: isHangDiemStore,
                        iconHangDiem: iconHangDiem
                    }, "".concat(sku, "-").concat(index));
                }),
                (remainTags === null || remainTags === void 0 ? void 0 : remainTags.length) > 0 && /*#__PURE__*/ (0,jsx_runtime.jsx)(atoms_AdditionalTooltip, {
                    tags: remainTags
                })
            ]
        });
    }
    // isProductCard  = false -> trang chi tiết - hiển thị full,
    return setTags.map(function(item, index) {
        /*#__PURE__*/ return (0,jsx_runtime.jsx)(TagType/* default */.ZP, {
            item: item,
            exp: item !== "NEAR_EXPIRATION" ? statusData === null || statusData === void 0 ? void 0 : statusData.date : expiredDate,
            isTooltip: isProductCard && TagType/* tagTypePropsArr.indexOf */.fb.indexOf(item),
            isLinkTagDeal: isLinkTagDeal,
            link: link,
            isProductDetailPage: isProductDetailPage,
            isHangDiemStore: isHangDiemStore,
            iconHangDiem: iconHangDiem
        }, "".concat(sku, "-").concat(index));
    });
};
/* harmony default export */ var mocules_TagComponent = (/*#__PURE__*/(0,react.memo)(TagComponent));


/***/ }),

/***/ 85201:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";

// EXPORTS
__webpack_require__.d(__webpack_exports__, {
  "ZP": function() { return /* binding */ mocules_TagType; },
  "f9": function() { return /* binding */ getTagName; },
  "fb": function() { return /* binding */ tagTypePropsArr; }
});

// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread.mjs
var _object_spread = __webpack_require__(26042);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_object_spread_props.mjs
var _object_spread_props = __webpack_require__(69396);
// EXTERNAL MODULE: ./node_modules/react/jsx-runtime.js
var jsx_runtime = __webpack_require__(85893);
// EXTERNAL MODULE: ./src/constants/Tags/index.js
var Tags = __webpack_require__(91983);
// EXTERNAL MODULE: ./src/constants/TagTypeProps/index.js
var TagTypeProps = __webpack_require__(11917);
// EXTERNAL MODULE: ./src/context/Auth/index.js + 4 modules
var Auth = __webpack_require__(95581);
// EXTERNAL MODULE: ./src/sysconfig/index.js
var sysconfig = __webpack_require__(66225);
// EXTERNAL MODULE: ./src/utils/DateTimeUtils.js
var DateTimeUtils = __webpack_require__(33213);
// EXTERNAL MODULE: ./src/zustand-lib/storeGlobal.js + 2 modules
var storeGlobal = __webpack_require__(31439);
// EXTERNAL MODULE: ./node_modules/@swc/helpers/src/_define_property.mjs
var _define_property = __webpack_require__(14924);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Grid/Grid.js
var Grid = __webpack_require__(41749);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Tooltip/Tooltip.js
var Tooltip = __webpack_require__(868);
// EXTERNAL MODULE: ./node_modules/@material-ui/core/esm/Typography/Typography.js
var Typography = __webpack_require__(22318);
// EXTERNAL MODULE: ./node_modules/clsx/dist/clsx.mjs
var clsx = __webpack_require__(90512);
// EXTERNAL MODULE: ./src/components/atoms/LinkComp/index.js
var LinkComp = __webpack_require__(24618);
// EXTERNAL MODULE: ./src/constants/Paths/index.js
var Paths = __webpack_require__(199);
// EXTERNAL MODULE: ./src/utils/gtag.js
var gtag = __webpack_require__(57059);
// EXTERNAL MODULE: ./src/utils/ImageFallback.tsx
var ImageFallback = __webpack_require__(43931);
// EXTERNAL MODULE: ./src/zustand-lib/storeMobile.js
var storeMobile = __webpack_require__(35810);
// EXTERNAL MODULE: ./src/components/mocules/ProductTag/tag.module.css
var tag_module = __webpack_require__(12404);
var tag_module_default = /*#__PURE__*/__webpack_require__.n(tag_module);
;// CONCATENATED MODULE: ./src/components/mocules/ProductTag/index.js













var getUrlTag = function(param) {
    var slug = param.slug, url = param.url, code = param.code;
    // TODO: url maybe is []string in useDealTagUrl
    if (url) {
        if (Array.isArray(url)) {
            return url.join();
        } else {
            return url;
        }
    }
    if (slug) return "/tag/".concat(slug);
    return "".concat(Paths/* PRODUCTS_LOADING_URL */.iB, "?tag=").concat(code);
};
function ProductTag(param) {
    var name = param.name, preIcon = param.preIcon, _Icon = param.Icon, Icon = _Icon === void 0 ? null : _Icon, nameAsTooltip = param.nameAsTooltip, textColor = param.textColor, style = param.style, styleName = param.styleName, code = param.code, backgroundColor = param.backgroundColor, date = param.date, _isTooltip = param.isTooltip, isTooltip = _isTooltip === void 0 ? false : _isTooltip, _url = param.url, url = _url === void 0 ? null : _url, borderColor = param.borderColor, _isStyleV2 = param.isStyleV2, isStyleV2 = _isStyleV2 === void 0 ? false : _isStyleV2, slug = param.slug, link = param.link, isLinkTagDeal = param.isLinkTagDeal, _isProductDetailPage = param.isProductDetailPage, isProductDetailPage = _isProductDetailPage === void 0 ? false : _isProductDetailPage, _horizontalIconSvg = param.horizontalIconSvg, horizontalIconSvg = _horizontalIconSvg === void 0 ? "" : _horizontalIconSvg, _isHangDiemStore = param.isHangDiemStore, isHangDiemStore = _isHangDiemStore === void 0 ? false : _isHangDiemStore, _hangDiemLink = param.hangDiemLink, hangDiemLink = _hangDiemLink === void 0 ? "" : _hangDiemLink;
    var ref, ref1;
    var isMobileV2 = (0,storeMobile/* default */.Z)(function(state) {
        return state.isMobileV2();
    });
    // TODO: special case, only display tag dynamic in product detail page for "hang diem" store
    if (isHangDiemStore && code === "2ABC") {
        // remove redirect link for this case
        if (isProductDetailPage) {
            return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
                stopProp: true,
                removeStyles: true,
                href: hangDiemLink,
                "data-tag": "tags-".concat(code),
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                    className: "relative min-w-[92px] h-[24px]",
                    onClick: function() {
                        return gtag/* default.clickTagInProduct */.ZP.clickTagInProduct(name);
                    },
                    children: /*#__PURE__*/ (0,jsx_runtime.jsx)(ImageFallback/* default */.ZP, {
                        src: horizontalIconSvg,
                        objectFit: "cover",
                        layout: "fill",
                        alt: "tag hang hang"
                    })
                })
            });
        }
        var _obj;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
            stopProp: true,
            removeStyles: true,
            href: hangDiemLink,
            "data-test": "tags-".concat(code),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                title: name || "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    style: (0,_object_spread/* default */.Z)({
                        borderColor: borderColor || backgroundColor,
                        color: textColor,
                        backgroundColor: backgroundColor
                    }, style || {}),
                    className: (0,clsx/* default */.Z)((_obj = {}, (0,_define_property/* default */.Z)(_obj, (tag_module_default()).icon_tag_container, !isStyleV2), (0,_define_property/* default */.Z)(_obj, (tag_module_default()).tag_containerv2, isStyleV2), _obj)),
                    onClick: function() {
                        gtag/* default.clickTagInProduct */.ZP.clickTagInProduct(name);
                    },
                    children: Icon && Icon
                })
            })
        });
    }
    // parse preIcon
    if (preIcon) {
        if (typeof preIcon === "string") {
            if (preIcon.indexOf(" ") > 0) {
                preIcon = preIcon.split(" ");
            }
        } else if (typeof preIcon === "object" && preIcon.value) {
            preIcon = preIcon.value;
        }
    }
    // capitalize
    name = (ref1 = (ref = name === null || name === void 0 ? void 0 : name.split(" ")) === null || ref === void 0 ? void 0 : ref.map(function(word) {
        return word.length > 1 ? word.charAt(0).toUpperCase() + word.substr(1) : word.toUpperCase();
    })) === null || ref1 === void 0 ? void 0 : ref1.join(" ");
    if (isTooltip && (Icon || preIcon)) {
        var urlTag = getUrlTag({
            code: code,
            url: code === "DEAL" && isLinkTagDeal ? link : url,
            slug: slug
        });
        var _obj1;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
            stopProp: true,
            removeStyles: true,
            href: urlTag,
            "data-test": "tags-".concat(code),
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
                title: name || "",
                children: /*#__PURE__*/ (0,jsx_runtime.jsx)(Grid/* default */.Z, {
                    style: (0,_object_spread/* default */.Z)({
                        borderColor: borderColor || backgroundColor,
                        color: textColor,
                        backgroundColor: backgroundColor
                    }, style || {}),
                    // className={isStyleV2 ? styles.tag_containerv2 : styles.icon_tag_container}
                    className: (0,clsx/* default */.Z)((_obj1 = {}, (0,_define_property/* default */.Z)(_obj1, (tag_module_default()).icon_tag_container, !isStyleV2), (0,_define_property/* default */.Z)(_obj1, (tag_module_default()).tag_containerv2, isStyleV2), (0,_define_property/* default */.Z)(_obj1, (tag_module_default()).tag_container_mobilev2, isMobileV2), _obj1)),
                    onClick: function() {
                        gtag/* default.clickTagInProduct */.ZP.clickTagInProduct(name);
                    },
                    children: Icon && Icon
                })
            })
        });
    }
    // normal display
    if (!nameAsTooltip && name) {
        var urlTag1 = getUrlTag({
            code: code,
            url: code === "DEAL" && isLinkTagDeal ? link : url,
            slug: slug
        });
        var _obj2, _obj3;
        return /*#__PURE__*/ (0,jsx_runtime.jsx)(LinkComp/* default */.Z, {
            stopProp: true,
            removeStyles: true,
            href: urlTag1,
            "data-test": "tags-".concat(code),
            children: /*#__PURE__*/ (0,jsx_runtime.jsxs)(Grid/* default */.Z, {
                style: (0,_object_spread/* default */.Z)({
                    borderColor: borderColor || backgroundColor,
                    color: textColor,
                    backgroundColor: backgroundColor
                }, style || {}),
                // className={clsx(isStyleV2 ? styles.tag_containerv2 : styles.tag_container, date ? styles.date_tag_container : styles.normal_tag_container)}
                className: (0,clsx/* default */.Z)((_obj2 = {}, (0,_define_property/* default */.Z)(_obj2, (tag_module_default()).tag_container, !isStyleV2), (0,_define_property/* default */.Z)(_obj2, (tag_module_default()).tag_containerv2, isStyleV2), (0,_define_property/* default */.Z)(_obj2, (tag_module_default()).normal_tag_container, !date), (0,_define_property/* default */.Z)(_obj2, (tag_module_default()).date_tag_container, date), (0,_define_property/* default */.Z)(_obj2, (tag_module_default()).tag_container_mobilev2, isMobileV2), _obj2)),
                onClick: function() {
                    gtag/* default.clickTagInProduct */.ZP.clickTagInProduct(name);
                },
                children: [
                    Icon && Icon,
                    /*#__PURE__*/ (0,jsx_runtime.jsx)(Typography/* default */.Z, {
                        className: (0,clsx/* default */.Z)((_obj3 = {}, (0,_define_property/* default */.Z)(_obj3, (tag_module_default()).nameTag, true), (0,_define_property/* default */.Z)(_obj3, (tag_module_default()).nameTagMobileV2, isMobileV2), _obj3)),
                        style: (0,_object_spread/* default */.Z)({}, styleName || {}),
                        children: name
                    })
                ]
            })
        });
    }
    // quick order display
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(jsx_runtime.Fragment, {
        children: preIcon && name && /*#__PURE__*/ (0,jsx_runtime.jsx)(Tooltip/* default */.ZP, {
            title: name,
            children: /*#__PURE__*/ (0,jsx_runtime.jsx)("div", {
                style: (0,_object_spread/* default */.Z)({
                    borderColor: borderColor || backgroundColor,
                    color: textColor,
                    backgroundColor: backgroundColor
                }, style || {}),
                className: isStyleV2 ? (tag_module_default()).tag_containerv2 : (tag_module_default()).tag_container,
                data: "no link",
                children: Icon && Icon
            })
        })
    });
};

;// CONCATENATED MODULE: ./src/components/mocules/TagType/index.js










var tagTypePropsArr = [
    "OUT_OF_STOCK",
    "SUSPENDED",
    "GIFT",
    "FLASH_SALE",
    "MEGA_DAY",
    "DEAL",
    sysconfig/* TAG_HANG_DAT_TRUOC */.lE,
    "FV2U",
    Tags/* PRODUCT_TAG.HANG_DIEM */.d.HANG_DIEM,
    Tags/* PRODUCT_TAG.HANG_HANG */.d.HANG_HANG,
    Tags/* PRODUCT_TAG.HOADONNHANH */.d.HOADONNHANH,
    Tags/* PRODUCT_TAG.BANCHAY */.d.BANCHAY,
    "BAN_CHAY",
    "84AB",
    "3ABC", 
];
var tagIconArr = [
    "GIAONHANH",
    "W80T",
    "BAN_CHAY",
    "BANCHAY",
    "HOADONNHANH"
];
var tagNoDisplayArr = [
    sysconfig/* TAG_NEW */.cC
];
var getTagName = function(item, getStyleBySlugOfTag) {
    var ref;
    if (item === "NEAR_EXPIRATION") {
        return "Cận date";
    }
    if ((tagNoDisplayArr === null || tagNoDisplayArr === void 0 ? void 0 : tagNoDisplayArr.indexOf(item)) >= 0) {
        return null;
    }
    var tagInfo = TagTypeProps/* default */.Z[item];
    if (tagInfo === null || tagInfo === void 0 ? void 0 : tagInfo.name) {
        return tagInfo.name;
    }
    return ((ref = getStyleBySlugOfTag(item)) === null || ref === void 0 ? void 0 : ref.name) || "";
};
// notes
// cận date chưa làm ,  nếu có status cận date
// khuyến mãi , nếu có deal tự thêm mã giảm giá vào tag
// nên chuyển về 1 cái , làm sau
var TagType = function(param) {
    var item = param.item, exp = param.exp, _isTooltip = param.isTooltip, isTooltip = _isTooltip === void 0 ? false : _isTooltip, _isDisplayFull = param.isDisplayFull, isDisplayFull = _isDisplayFull === void 0 ? false : _isDisplayFull, link = param.link, isLinkTagDeal = param.isLinkTagDeal, _isProductDetailNew = param.isProductDetailNew, isProductDetailNew = _isProductDetailNew === void 0 ? false : _isProductDetailNew, _isProductDetailPage = param.isProductDetailPage, isProductDetailPage = _isProductDetailPage === void 0 ? false : _isProductDetailPage, _isHangDiemStore = param.isHangDiemStore, isHangDiemStore = _isHangDiemStore === void 0 ? false : _isHangDiemStore, iconHangDiem = param.iconHangDiem;
    var getStyleBySlugOfTag = (0,storeGlobal/* useStore */.oR)(function(state) {
        return state.getStyleBySlugOfTag;
    });
    var customerInfo = (0,Auth/* useAuth */.aC)().customerInfo;
    var props = {};
    if (item === sysconfig/* TAG_HANG_DAT_TRUOC */.lE && sysconfig/* REGION_MB.indexOf */.nt.indexOf("".concat(customerInfo === null || customerInfo === void 0 ? void 0 : customerInfo.provinceCode)) < 0) {
        return null;
    }
    if (item === "NEAR_EXPIRATION") {
        var date = DateTimeUtils/* default.getFormattedDate */.ZP.getFormattedDate(new Date(exp), "DD-MM-YYYY");
        var _NEAR_EXPIRATION = TagTypeProps/* default.NEAR_EXPIRATION */.Z.NEAR_EXPIRATION, name = _NEAR_EXPIRATION.name, code = _NEAR_EXPIRATION.code, textColor = _NEAR_EXPIRATION.textColor, backgroundColor = _NEAR_EXPIRATION.backgroundColor, url = _NEAR_EXPIRATION.url;
        props = {
            name: "".concat(name, " ").concat(isProductDetailNew ? "" : date),
            date: date,
            code: code,
            textColor: textColor,
            backgroundColor: backgroundColor,
            url: url
        };
    } else if (!isDisplayFull && (tagNoDisplayArr === null || tagNoDisplayArr === void 0 ? void 0 : tagNoDisplayArr.indexOf(item)) >= 0) {
        return null;
    } else {
        // nếu ko có option nào thì lấy theo API trả về
        var tagInfo = TagTypeProps/* default */.Z[item];
        // TODO: property of tag "HANG DIEM" will take from internal tag/edit
        if (isHangDiemStore && (tagInfo === null || tagInfo === void 0 ? void 0 : tagInfo.code) === "2ABC") {
            if (isProductDetailPage) {
                // keep the code, change another one
                tagInfo = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, iconHangDiem), {
                    code: "2ABC",
                    hangDiemLink: link
                });
            } else {
                // keep current tagInfo, change the name
                tagInfo = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tagInfo), {
                    name: iconHangDiem === null || iconHangDiem === void 0 ? void 0 : iconHangDiem.name,
                    hangDiemLink: link
                });
            }
        }
        props = tagInfo ? (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, tagInfo), {
            isTooltip: isTooltip,
            isProductDetailPage: isProductDetailPage,
            isHangDiemStore: isHangDiemStore
        }) : getStyleBySlugOfTag(item);
        if (props && !(props === null || props === void 0 ? void 0 : props.name)) {
            var ref;
            props.name = ((ref = getStyleBySlugOfTag(item)) === null || ref === void 0 ? void 0 : ref.name) || "";
        }
        if (props && !(props === null || props === void 0 ? void 0 : props.slug)) {
            var ref1;
            props.slug = ((ref1 = getStyleBySlugOfTag(item)) === null || ref1 === void 0 ? void 0 : ref1.slug) || "";
        }
        if (!props) {
            return null;
        }
        if ((tagIconArr === null || tagIconArr === void 0 ? void 0 : tagIconArr.indexOf(item)) >= 0) {
            props = (0,_object_spread_props/* default */.Z)((0,_object_spread/* default */.Z)({}, props), {
                isTooltip: isTooltip
            });
        }
    }
    return /*#__PURE__*/ (0,jsx_runtime.jsx)(ProductTag, (0,_object_spread/* default */.Z)({
        link: link,
        isLinkTagDeal: isLinkTagDeal
    }, props));
};
/* harmony default export */ var mocules_TagType = (TagType);


/***/ }),

/***/ 60095:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "Me": function() { return /* binding */ ICON_TAG_GIAO_NHANH; },
/* harmony export */   "RK": function() { return /* binding */ ICON_TAG_QUA_TANG; },
/* harmony export */   "Si": function() { return /* binding */ ICON_TAG_CAN_DATE; },
/* harmony export */   "Td": function() { return /* binding */ TAG_BAN_CHAY; },
/* harmony export */   "WE": function() { return /* binding */ ICON_TAG_DONG_Y; },
/* harmony export */   "XX": function() { return /* binding */ ICON_TAG_DOI_MAU; },
/* harmony export */   "_F": function() { return /* binding */ ICON_TAG_GAM_HANG_LANH; },
/* harmony export */   "b1": function() { return /* binding */ TAG_HANG_DIEM; },
/* harmony export */   "pN": function() { return /* binding */ ICON_TAG_SUC_KHOE_HAU_COVID; },
/* harmony export */   "we": function() { return /* binding */ TAG_HOA_DON_NHANH; }
/* harmony export */ });
/* unused harmony export ICON_TAG_THIET_BI_CAO_CAP */
var TAG_BAN_CHAY = "/icons/tag/ban_chay.svg";
var TAG_HOA_DON_NHANH = "/icons/tag/hoa_don_nhanh.svg";
// Đổi icon tag hàng điểm -> chị Ngọc Tạ nhờ 11Jun2022
var TAG_HANG_DIEM = "/icons/tag/tag_hang_diem.svg";
// export const ICON_VERIFIED = '/icons/tag/verified.svg';
var ICON_TAG_CAN_DATE = "/icons/tag/can_date.svg";
var ICON_TAG_DOI_MAU = "/icons/tag/doi_mau.svg";
var ICON_TAG_DONG_Y = "/icons/tag/dong_y.svg";
var ICON_TAG_GAM_HANG_LANH = "/icons/tag/gam_hang_lanh.svg";
var ICON_TAG_GIAO_NHANH = "/icons/tag/giao_nhanh.svg";
var ICON_TAG_QUA_TANG = "/icons/tag/qua_tang.svg";
var ICON_TAG_SUC_KHOE_HAU_COVID = "/icons/tag/suc_khoe_hau_covid.svg";
var ICON_TAG_THIET_BI_CAO_CAP = "/icons/tag/thiet_bi_cao_cap.svg";


/***/ }),

/***/ 11917:
/***/ (function(__unused_webpack_module, __webpack_exports__, __webpack_require__) {

"use strict";
/* harmony export */ __webpack_require__.d(__webpack_exports__, {
/* harmony export */   "D": function() { return /* binding */ ImageTag; }
/* harmony export */ });
/* harmony import */ var _swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__ = __webpack_require__(26042);
/* harmony import */ var _swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__ = __webpack_require__(69396);
/* harmony import */ var react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__ = __webpack_require__(85893);
/* harmony import */ var constants_Icons__WEBPACK_IMPORTED_MODULE_1__ = __webpack_require__(43004);
/* harmony import */ var constants_Icons_tag__WEBPACK_IMPORTED_MODULE_7__ = __webpack_require__(60095);
/* harmony import */ var sysconfig__WEBPACK_IMPORTED_MODULE_2__ = __webpack_require__(66225);
/* harmony import */ var utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__ = __webpack_require__(43931);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_4__ = __webpack_require__(54248);
/* harmony import */ var _style_module_css__WEBPACK_IMPORTED_MODULE_4___default = /*#__PURE__*/__webpack_require__.n(_style_module_css__WEBPACK_IMPORTED_MODULE_4__);
// TODO: refactor contanst








var ImageTag = function(param) {
    var src = param.src;
    return /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(utils_ImageFallback__WEBPACK_IMPORTED_MODULE_3__/* .ImageFallbackStatic */ .ez, {
        src: src,
        width: 15,
        height: 15,
        className: (_style_module_css__WEBPACK_IMPORTED_MODULE_4___default().icon_svg)
    });
};
var defaultNewStyle = {
    border: "1px solid var(--primary-color)",
    textColor: "var(--primary-color)",
    borderColor: "#F2F4FA",
    backgroundColor: "#F2F4FA",
    isStyleV2: true,
    styleName: {
        fontFamily: "ggsr"
    }
};
var TagTypeProps = {
    default: {
        border: "1px solid #000",
        color: "#000"
    },
    NEAR_EXPIRATION: {
        code: "NEAR_EXPIRATION",
        name: "Cận date",
        textColor: "#D4323B",
        backgroundColor: "#FFF4EF",
        index: 100,
        url: "/products"
    },
    GIFT: {
        code: "GIFT",
        name: "Qu\xe0 tặng",
        textColor: "#ff4fae"
    },
    MEGA_DAY: {
        name: "Mega Day",
        textColor: "var(--primary-color)",
        backgroundColor: "#F2F4FD"
    },
    FLASH_SALE: {
        name: "Flash Sale",
        textColor: "var(--primary-color)",
        backgroundColor: " #F2F4FD",
        url: "/deals"
    },
    // Ẩn tag "Khuyến mãi" (DEAL) trên toàn bộ trang - tag 'DEAL' vẫn còn trong product.tags để giữ logic sắp xếp (getSortedProducts)
    // DEAL: {
    //   border: '1px solid #dc3545',
    //   color: '#dc3545',
    //   name: 'Khuyến mãi',
    //   textColor: '#fff',
    //   backgroundColor: '#dc3545',
    //   url: '/deals',
    //   code: 'DEAL',
    // },
    HANG_DAT_TRUOC: {
        code: "HANG_DAT_TRUOC",
        border: "1px solid #FDB971",
        name: "Đặt trước 7 ng\xe0y",
        backgroundColor: "#FF9B05",
        color: "#FFFFFF",
        textColor: "#FFFFFF",
        index: 98
    },
    //  off limit
    LIMIT: {
        code: "LIMIT",
        name: "Số lượng c\xf3 hạn",
        textColor: "#D14900",
        backgroundColor: "#FFF8EA",
        url: "/products"
    },
    FV2U: {
        code: "FV2U",
        name: "C\xf3 Ở Kho",
        textColor: "var(--primary-color)",
        backgroundColor: "#F3F3FC",
        Icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageTag, {
            src: constants_Icons__WEBPACK_IMPORTED_MODULE_1__/* .ICON_CO_O_KHO */ .vIG
        })
    },
    // Logo hàng hãng 12May2022 - chị ngọc nhờ
    "2ABC": {
        code: "2ABC",
        name: "",
        textColor: "#FFF",
        color: "#D6A816",
        backgroundColor: "#D6A816",
        isTooltip: true,
        Icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageTag, {
            src: constants_Icons__WEBPACK_IMPORTED_MODULE_1__/* .TAG_LOGO_HANG_HANG */ .ins
        }),
        index: 99
    },
    // new style
    BAN_CHAY: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, defaultNewStyle), {
        code: "BAN_CHAY",
        name: "B\xe1n Chạy",
        isTooltip: true,
        Icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageTag, {
            src: constants_Icons_tag__WEBPACK_IMPORTED_MODULE_7__/* .TAG_BAN_CHAY */ .Td
        }),
        index: 97
    }),
    "3ABC": (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, defaultNewStyle), {
        code: "3ABC",
        name: "B\xe1n Chạy",
        isTooltip: true,
        Icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageTag, {
            src: constants_Icons_tag__WEBPACK_IMPORTED_MODULE_7__/* .TAG_BAN_CHAY */ .Td
        }),
        index: 97
    }),
    HOADONNHANH: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, defaultNewStyle), {
        name: "H\xf3a Đơn Nhanh",
        code: "HOADONNHANH",
        isTooltip: true,
        Icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageTag, {
            src: constants_Icons_tag__WEBPACK_IMPORTED_MODULE_7__/* .TAG_HOA_DON_NHANH */ .we
        }),
        index: 99
    }),
    Y7GB: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, defaultNewStyle), {
        code: "Y7GB",
        name: "H\xe0ng Điểm",
        isTooltip: true,
        Icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageTag, {
            src: constants_Icons_tag__WEBPACK_IMPORTED_MODULE_7__/* .TAG_HANG_DIEM */ .b1
        }),
        index: 98
    }),
    YEU_CAU_GPP_GDP: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, defaultNewStyle), {
        name: "Y\xeau Cầu C\xf3 GPP/GDP",
        index: 95
    }),
    GIAO_NHANH: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, defaultNewStyle), {
        name: "Giao Nhanh",
        isTooltip: true,
        Icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageTag, {
            src: constants_Icons_tag__WEBPACK_IMPORTED_MODULE_7__/* .ICON_TAG_GIAO_NHANH */ .Me
        }),
        index: 90
    }),
    DONG_Y: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, defaultNewStyle), {
        name: "Đ\xf4ng Y",
        isTooltip: true,
        Icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageTag, {
            src: constants_Icons_tag__WEBPACK_IMPORTED_MODULE_7__/* .ICON_TAG_DONG_Y */ .WE
        }),
        index: 93
    }),
    CAN_DATE: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, defaultNewStyle), {
        name: "Cận Date",
        isTooltip: true,
        Icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageTag, {
            src: constants_Icons_tag__WEBPACK_IMPORTED_MODULE_7__/* .ICON_TAG_CAN_DATE */ .Si
        })
    }),
    GAM_HANG_LANH: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, defaultNewStyle), {
        name: "Gam H\xe0ng Lạnh",
        isTooltip: true,
        Icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageTag, {
            src: constants_Icons_tag__WEBPACK_IMPORTED_MODULE_7__/* .ICON_TAG_GAM_HANG_LANH */ ._F
        }),
        index: 92
    }),
    DOI_MAU: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, defaultNewStyle), {
        name: "Đổi Mẫu",
        isTooltip: true,
        Icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageTag, {
            src: constants_Icons_tag__WEBPACK_IMPORTED_MODULE_7__/* .ICON_TAG_DOI_MAU */ .XX
        }),
        index: 95
    }),
    QUA_TANG: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, defaultNewStyle), {
        name: "Qu\xe0 Tặng",
        isTooltip: true,
        Icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageTag, {
            src: constants_Icons_tag__WEBPACK_IMPORTED_MODULE_7__/* .ICON_TAG_QUA_TANG */ .RK
        }),
        index: 89
    }),
    SUC_KHOE_HAU_COVID: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, defaultNewStyle), {
        name: "Sức Khoẻ Hậu Covid",
        isTooltip: true,
        Icon: /*#__PURE__*/ (0,react_jsx_runtime__WEBPACK_IMPORTED_MODULE_0__.jsx)(ImageTag, {
            src: constants_Icons_tag__WEBPACK_IMPORTED_MODULE_7__/* .ICON_TAG_SUC_KHOE_HAU_COVID */ .pN
        }),
        index: 91
    })
};
var tagsStyles = {
    dev: {
        BANCHAY: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.BAN_CHAY), {
            code: "BANCHAY"
        }),
        X7GB: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.YEU_CAU_GPP_GDP), {
            code: "X7GB"
        }),
        PABC: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.DONG_Y), {
            code: "PABC"
        }),
        DOIMAU: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.DOI_MAU), {
            code: "DOIMAU"
        }),
        GIAONHANH: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.GIAO_NHANH), {
            code: "GIAONHANH"
        }),
        LY7G: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.SUC_KHOE_HAU_COVID), {
            code: "LY7G"
        })
    },
    stg: {
        "84AB": (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.BAN_CHAY), {
            code: "84AB"
        }),
        GIAONHANH: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.GIAO_NHANH), {
            code: "GIAONHANH"
        }),
        DOIMAU: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.DOI_MAU), {
            code: "DOIMAU"
        }),
        LY7G: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.SUC_KHOE_HAU_COVID), {
            code: "LY7G"
        }),
        X7GB: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.YEU_CAU_GPP_GDP), {
            code: "X7GB"
        }),
        PABC: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.DONG_Y), {
            code: "PABC"
        })
    },
    uat: {
        X7GB: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.YEU_CAU_GPP_GDP), {
            code: "X7GB"
        }),
        PABC: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.DONG_Y), {
            code: "PABC"
        }),
        DOIMAU: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.DOI_MAU), {
            code: "DOIMAU"
        }),
        GIAONHANH: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.GIAO_NHANH), {
            code: "GIAONHANH"
        }),
        LY7G: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.SUC_KHOE_HAU_COVID), {
            code: "LY7G"
        })
    },
    prd: {
        X7GB: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.YEU_CAU_GPP_GDP), {
            code: "X7GB"
        }),
        PABC: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.DONG_Y), {
            code: "PABC"
        }),
        DOIMAU: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.DOI_MAU), {
            code: "DOIMAU"
        }),
        GIAONHANH: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.GIAO_NHANH), {
            code: "GIAONHANH"
        }),
        LY7G: (0,_swc_helpers_src_object_spread_props_mjs__WEBPACK_IMPORTED_MODULE_5__/* ["default"] */ .Z)((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps.SUC_KHOE_HAU_COVID), {
            code: "LY7G"
        })
    }
};
/* harmony default export */ __webpack_exports__["Z"] = ((0,_swc_helpers_src_object_spread_mjs__WEBPACK_IMPORTED_MODULE_6__/* ["default"] */ .Z)({}, TagTypeProps, tagsStyles[sysconfig__WEBPACK_IMPORTED_MODULE_2__/* .ENV */ .Vi]));


/***/ }),

/***/ 59621:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"wrapLoad":"styles_wrapLoad__koJen","wrapper":"styles_wrapper__Xmdgo","progress":"styles_progress___u83G"};

/***/ }),

/***/ 84446:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"tag_quantity":"styles_tag_quantity__1qcXT","tag":"styles_tag__eOcXj","tag_mv2":"styles_tag_mv2__MRr7b"};

/***/ }),

/***/ 12404:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"date_tag_container":"tag_date_tag_container__bq5VK","tag_container":"tag_tag_container__Ypz6S","tag_containerv2":"tag_tag_containerv2__66m1A","normal_tag_container":"tag_normal_tag_container__Twl9u","icon_tag_container":"tag_icon_tag_container__1zOAv","nameTag":"tag_nameTag__RvjhU","nameTagMobileV2":"tag_nameTagMobileV2__E_Q_J","tag_container_mobilev2":"tag_tag_container_mobilev2__NWEoN"};

/***/ }),

/***/ 54248:
/***/ (function(module) {

// extracted by mini-css-extract-plugin
module.exports = {"icon":"style_icon__JH0TV","icon_svg":"style_icon_svg__xHhyG"};

/***/ })

}]);